import React, { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { GenericDiv, GenericSpan, UtilitySpriteIcon } from 'commonStyles';
import TrainBookingPage from './components/TrainBookingPage/TrainBookingPage';
import StatusPopup from '../shortListNShare/common/StatusPopup/StatusPopup';
import { TrainLandingWrapper, MobHeader } from './Style';
import useDeviceDetect from 'UtilityComponents/customeHooks/useDeviceDetect';
import { DisplayProvider, Devices } from 'UtilityComponents/displayContext';
import { PATHS } from 'AppConstants';

const TrainLanding = ({ isMobile }) => {
	const popupData = useSelector((state) => state.train.popupData || []);
	const isPopup = useSelector((state) => state.train.isPopup);

	const devicedetect = useDeviceDetect();
	const isMobileView = isMobile || devicedetect.isMobile;
	const isLandScape = devicedetect.isLandScape;

	const dispVal = useMemo(()=>({
		isMobile: isMobileView ? Devices.mobile : Devices.desktop,
		isLandScape: isLandScape
	}), [isMobileView, isLandScape]);

	const goToHome = useCallback(()=>{
		window.location = PATHS.MMT_MYBIZ;
	}, []);

	return (
		<TrainLandingWrapper isMobile={isMobileView}>
			<GenericDiv top_M={isMobileView ? '0' : '68'}>
				<DisplayProvider
					value={dispVal}>
					{isMobileView &&
					<MobHeader justify='flex-start' left_P='10' top_P='20' bottom_P='20' position='relative'>
						<UtilitySpriteIcon className='backArrow' onClick={goToHome} />
						<GenericSpan fsize='22px'>
							Book
							<GenericSpan left_M='5' f_weight='900' fsize='22px'>Train Tickets</GenericSpan>
						</GenericSpan>
					</MobHeader>}
					<TrainBookingPage isMobile={isMobileView} />
				</DisplayProvider>
			</GenericDiv>
			{isPopup && <StatusPopup {...popupData} btnType={isMobileView && 'Flat'} btnWidth={isMobileView && '100%'} />}
		</TrainLandingWrapper>
	);
};

export default TrainLanding;
